import React, { useContext, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import CircularProgress from '@material-ui/core/CircularProgress'
import AddItem from './components/add-item'
import FoodForm from './components/food-form'
import { convertNutritionixData } from './components/util'
import Item from '../inspect/components/tracker/item'
import GenericItem from '../../../../images/genericFood.png'
import {ReactComponent as AddIcon } from '../../../../images/iconAdd.svg'
import { getFavoriteDays, insertFavoriteDay, updateFavoriteDay } from '../../../../api'
import { lookupBrandItem, lookupNaturalItem } from '../../../../nutritionix'
import { AuthContext } from '../../../../auth-context'
import Button from '../../../../components/button'
import Input from '../../../../components/input'
import '../../../../css/add-item.sass'
import { DashboardContext } from '../../dashboard-context'
import {MacrosDisplay} from './components/macros-display'

const MEAL_LABELS = {
  breakfast: 'Breakfast',
  lunch: 'Lunch',
  dinner: 'Dinner',
  snacks: 'Snacks',
  other: 'Other'
}

const DayContainer = styled.div`
  margin: 0 auto;
  max-width: 1000px;
  padding: 64px 32px;
`

const PageTitle = styled.h2`
  margin: 0 auto 30px auto;
  color: #555;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 600;
`

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 20px;

  @media(max-width: 900px) {
    margin-top: 16px;
  }
`

const AddButton = styled(Button)`
  margin: 0;
  margin-right: 16px;
  min-width: 180px;
`

const DayEdit = (props) => {
  const dayIdStr = props.match.params.id
  const { user } = useContext(AuthContext)
  const { openSnackbar } = useContext(DashboardContext)
  const [proxyUserId, updateProxyUserId] = useState(null)
  const [days, updateDays] = useState(null)
  const [name, updateName] = useState(null)
  const [meals, updateMeals] = useState(null)
  const [notes, updateNotes] = useState(null)
  const [nameError, updateNameError] = useState(false)
  const [dayStatus, updateDayStatus] = useState(0)
  const [category, updateCategory] = useState(null)
  const [itemType, updateItemType] = useState('food')
  const [showAddItemModal, updateShowAddItemModal] = useState(false)
  const [showFoodForm, updateShowFoodForm] = useState(false)
  const [foodLoading, updateFoodLoading] = useState(false)
  const [foodItem, updateFoodItem] = useState(null)
  const [foodKind, updateFoodKind] = useState(null)
  const [editingItemIndex, updateEditingItemIndex] = useState(null)
  const [saving, updateSaving] = useState(false)
  const [search, updateSearch] = useState('')

  useEffect(() => {
    if(dayStatus === 0) {
      updateDayStatus(1)
      getFavoriteDays(user.id).then((res) => {
        updateProxyUserId(res.data.proxy_user_id)
        updateDays(res.data.days)
        let meals = {}
        for (const c in MEAL_LABELS) {
          meals[c] = []
        } 
        if (dayIdStr === '0') {
          updateName('')
          updateMeals(meals)
          updateNotes('')
        } else {
          const dayId = Number(dayIdStr)
          for (let n = 0; n < res.data.days.length; ++n) {
            if (res.data.days[n].id === dayId) {
              updateName(res.data.days[n].name)
              res.data.days[n].meals.forEach((meal) => {
                meals[meal.category] = meal.foods
              })
              updateMeals(meals)
              updateNotes(res.data.days[n].notes)
              break
            }
          }
        }
        updateDayStatus(2)
      })
    }
  }, [dayIdStr, dayStatus, user.id])

  const handleAddFood = (c) => {
    updateCategory(c)
    updateShowAddItemModal(true)
  }

  const handleItemAfterQuery = (res) => {
    let newFood = convertNutritionixData(res.data.foods[0])
    newFood.itemType = itemType
    updateFoodItem(newFood)
    updateFoodLoading(false)
  }

  const handleAddItemPress = (item) => {
    updateShowAddItemModal(false)
    updateFoodLoading(true)
    if (item.nix_item_id) {
      updateFoodKind('brand')
      updateShowFoodForm(true)
      lookupBrandItem(proxyUserId, item.nix_item_id).then(handleItemAfterQuery).catch((err) => {
        console.log('lookupBrandItem failed')
        console.log(err)
        updateShowFoodForm(false)
        updateFoodLoading(false)
        updateShowAddItemModal(true)
      })
    } else {
      updateFoodKind('natural')
      updateShowFoodForm(true)
      lookupNaturalItem(proxyUserId, item.food_name).then(handleItemAfterQuery).catch((err) => {
        console.log('lookupNaturalItem failed')
        console.log(err)
        updateShowFoodForm(false)
        updateFoodLoading(false)
        updateShowAddItemModal(true)
      })
    }
  }

  const handleAddCustomPress = () => {
    updateShowAddItemModal(false)
    updateFoodLoading(false)
    updateFoodItem(null)
    updateFoodKind('custom')
    updateShowFoodForm(true)
  }

  const handleEditCurrent = (c, itemIndex) => {
    updateCategory(c)
    const editingItem = new Item(meals[c][itemIndex])
    updateEditingItemIndex(itemIndex)
    updateFoodLoading(false)
    updateFoodItem(editingItem)
    updateFoodKind('current')
    updateShowFoodForm(true)
  }

  const handleFoodFormClose = () => {
    updateShowFoodForm(false)
    if (foodKind !== 'current') {
      updateShowAddItemModal(true)
    }
  }

  const handleFoodFormSubmit = (item) => {
    let newFoods = meals[category].slice(0)
    if (foodKind === 'current') {
      newFoods.splice(editingItemIndex, 1, item)
    } else {
      newFoods.push(item)
    }
    let newMeals = Object.assign({}, meals)
    newMeals[category] = newFoods
    updateMeals(newMeals)
    updateShowFoodForm(false)
    updateSearch('')
  }

  const handleQuickDelete = () => {
    if (foodKind === 'current') {
      let newFoods = meals[category].slice(0)
      newFoods.splice(editingItemIndex, 1)
      let newMeals = Object.assign({}, meals)
      newMeals[category] = newFoods
      updateMeals(newMeals)
    }
    updateShowFoodForm(false)
  }

  const handleSaveTemplateDay = () => {
    if (name === '') {
      updateNameError(true)
      openSnackbar('Please enter a name for this day template.', true)
    } else {
      const lcName = name.toLowerCase()
      let duplicate = false
      for (let n = 0; n < days.length; ++n) {
        if (days[n].name.toLowerCase() === lcName) {
          if (dayIdStr === '0' || days[n].id !== Number(dayIdStr)) {
            duplicate = true
          }
          break
        }
      }
      if (duplicate) {
        updateNameError(true)
        openSnackbar('A day template with this name already exists.', true)
      } else {
        updateNameError(false)
        if (!saving) {
          updateSaving(true)
          let storedMeals = []
          for (const c in MEAL_LABELS) {
            if (meals[c].length !== 0) {
              storedMeals.push({category: c, foods: meals[c]})
            }
          }
          if (dayIdStr === '0') {
            insertFavoriteDay(user.id, name, storedMeals, notes).then((res) => {
              updateSaving(false)
              window.localStorage.setItem('pendingSnackbar', 'The day template was successfully added.')
              props.history.push('/dashboard/templates')
            })
          } else {
            updateFavoriteDay(user.id, Number(dayIdStr), name, storedMeals, notes).then((res) => {
              updateSaving(false)
              window.localStorage.setItem('pendingSnackbar', 'The day template was successfully updated.')
              props.history.push('/dashboard/templates')
            })
          }
        }
      }
    }
  }

  const handleCancel = () => {
    props.history.push('/dashboard/templates')
  }

  const renderTotalMacros = () => {
    if (!meals) return

    let protein = 0;
    let carbs = 0;
    let fat = 0;
    let calories = 0;
    let fiber = 0;

    const addMacros = (p, c, f, fib) => {
      protein += p
      carbs += c
      fat += f
      fiber += fib
    }

    for(const meal in meals) {
      const foods = meals[meal]
      foods.forEach((entry) => {
        const item = new Item(entry);
        if (item.itemType === "recipe") {
          addMacros(item.getRecipeProtein(), item.getRecipeCarbs(), item.getRecipeFat(), item.getRecipeFiber())
        } else {
          addMacros(item.getProtein(), item.getCarbs(), item.getFat(), item.getFiber())
        }
      })
    };

    protein = protein.toFixed(1);
    carbs = carbs.toFixed(1);
    fat = fat.toFixed(1);
    calories = (4 * (Number(carbs) + Number(protein)) + (9 * Number(fat))).toFixed(0)
    fiber = fiber.toFixed(1);

    return (
      <MacrosDisplay 
        protein={protein}
        carbs={carbs}
        fat={fat}
        calories={calories}
        fiber={fiber}
      />
    );
  };

  const renderMacros = (c) => {
    let totalProtein = 0
    let totalCarbs = 0
    let totalFats = 0
    let totalCalories = 0

    meals[c].forEach((foodItem) => {
      const item = new Item(foodItem)
      if (foodItem.itemType === 'recipe') {
        totalProtein += item.getRecipeProtein()
        totalCarbs += item.getRecipeCarbs()
        totalFats += item.getRecipeFat()
      } else {
        totalProtein += item.getProtein()
        totalCarbs += item.getCarbs()
        totalFats += item.getFat()
      }
    })

    totalCalories = (4 * (totalCarbs + totalProtein) + (9 * totalFats)).toFixed(0)

    return (
      <div className="category-macros">
        <label>{MEAL_LABELS[c]}</label>
        <div className="macros">
          <div className="tracker-macros-container">
            <p>{totalProtein.toFixed(1)} P</p>
            <p>{totalCarbs.toFixed(1)} C</p>
            <p>{totalFats.toFixed(1)} F</p>
            <p>{totalCalories} Cal</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <React.Fragment>
      <DayContainer>
        {dayStatus !== 2 ? (
          <CircularProgress size={32} />
        ) : (meals === null ? (
          <p>The day with id {dayIdStr} was not found.</p>
        ) : (
          <>
            <PageTitle>{dayIdStr === '0' ? 'Add' : 'Edit'} Day Template</PageTitle>
            <Input
              error={nameError}
              label="Name"
              value={name}
              onChange={updateName}
            />
            <Input
              label="Notes"
              value={notes}
              onChange={updateNotes}
            />
            {renderTotalMacros()}
            {Object.keys(MEAL_LABELS).map((c, index) => (
              <div key={index}>
                {renderMacros(c)}
                <div className="tracker-food-list">
                  {meals[c].map((foodItem, itemIndex) => {
                    const item = new Item(foodItem)
                    let protein
                    let carbs
                    let fat
                    if (foodItem.itemType === 'recipe') {
                      protein = item.getRecipeProtein()
                      carbs = item.getRecipeCarbs()
                      fat = item.getRecipeFat()
                    } else {
                      protein = item.getProtein()
                      carbs = item.getCarbs()
                      fat = item.getFat()
                    }
                    return (
                      <div style={{position: 'relative'}} key={itemIndex}>
                        <button className="tracker-item-timeline" onClick={() => handleEditCurrent(c, itemIndex)}>
                          <img className="tracker-item-thumbnail" src={foodItem.thumbnailUrl ? foodItem.thumbnailUrl : GenericItem} alt="food-thumbnail" />
                          <div className="tracker-item-data">
                            <p className="name">{foodItem.name}</p>
                            <div className="macros-container">
                              <p className="unit">{foodItem.serving} {foodItem.unit}</p>
                              <div className="macros">
                                {foodItem.itemType !== 'alcohol' && <p className="macro">{protein.toFixed(1)} P</p>}
                                <p className="macro">{carbs.toFixed(1)} C</p>
                                <p className="macro">{fat.toFixed(1)} F</p>
                              </div>
                            </div>
                          </div>    
                        </button>
                      </div>
                    )
                  })}
                </div>
                <button
                  className="tracker-add-item-button"
                  onClick={() => handleAddFood(c)}
                >
                  <AddIcon />
                  Add food
                </button>
              </div>
            ))}
            <ButtonContainer>
              <AddButton
                label="Save Day Template"
                onClick={handleSaveTemplateDay}
                isLoading={saving}
              />
              <AddButton
                label="Cancel"
                onClick={handleCancel}
              />
            </ButtonContainer>
            <AddItem
              search={search}
              updateSearch={updateSearch}
              open={showAddItemModal}
              onClose={() => updateShowAddItemModal(false)}
              proxyUserId={proxyUserId}
              itemType={itemType}
              updateItemType={updateItemType}
              handleAddItemPress={handleAddItemPress}
              handleAddCustomPress={handleAddCustomPress}
            />
            <FoodForm
              open={showFoodForm}
              onClose={handleFoodFormClose}
              handleFoodFormSubmit={handleFoodFormSubmit}
              handleQuickDelete={handleQuickDelete}
              foodLoading={foodLoading}
              foodItem={foodItem}
              updateFoodItem={updateFoodItem}
              itemType={itemType}
              foodKind={foodKind}
            />
          </>
        ))}
      </DayContainer>
    </React.Fragment>
  )
}

export default withRouter(DayEdit)